import request from "../request";
import sysrequest from "../sysrequest";
// search condition API

const api = {
  // 搜尋條件查詢
  sc_search(data) {
    const obj = {
      url: "/bid/demo_v1/search_condition/search/",
      method: "post",
      data,
      noAutoLogout: true, // 401 時不自動登出，讓程序繼續執行
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 搜尋條件更新
  sc_update(data) {
    const obj = {
      url: "/bid/demo_v1/search_condition/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 搜尋條件新增
  sc_create(data) {
    const obj = {
      url: "/bid/demo_v1/search_condition/create/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 搜尋條件刪除
  sc_delete(data) {
    const obj = {
      url: "/bid/demo_v1/search_condition/delete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
